import { render, staticRenderFns } from "./v-custom-fields-manager.vue?vue&type=template&id=325092b9&"
import script from "./v-custom-fields-manager.vue?vue&type=script&lang=js&"
export * from "./v-custom-fields-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports